import React, { useState, useRef, useEffect } from "react";
import { SketchPicker, ColorResult } from "react-color";
import colorPickerLogo from "../../../../../assets/image/png/color-picker-logo.png";
import {
  Box,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import { Colorize } from "@mui/icons-material";
import "../uiThemeConfig.css";

export interface ColorPickerWidgetPropsTypes {
  handleNewColor: (color: string) => void;
  currentColor: string;
}

const ColorPickerWidget: React.FC<ColorPickerWidgetPropsTypes> = ({
  handleNewColor,
  currentColor,
}) => {
  const [showPicker, setShowPicker] = useState<boolean>(false);
  const pickerRef = useRef<HTMLDivElement | null>(null);

  const handleColorChange = (color: ColorResult) => {
    console.log(JSON.stringify(color.hex));
    handleNewColor(color.hex);
  };

  const togglePicker = () => {
    setShowPicker(!showPicker);
  };
  const handleClose = () => setShowPicker(false);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        pickerRef.current &&
        !pickerRef.current.contains(event.target as Node)
      ) {
        handleClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <Box display="flex" marginTop={"8px"} alignItems={"center"}>
      <Box
        // flex="0.25"
        position="relative"
        border="1px solid #227C9D"
        borderRadius="4px"
        marginRight="10px"
        width={50}
        height={50}
        padding={0}
        sx={{
          backgroundImage: `url(${colorPickerLogo})`,
          backgroundSize: "contain",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <IconButton
          onClick={togglePicker}
          aria-label="toggle color picker"
          style={{
            width: 45,
            height: 45,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 0,
          }}
        >
          {/* <img
            src={colorPickerLogo}
            alt="Color Picker"
            style={{ width: 44, height: 44, objectFit: "cover" }}
          /> */}
        </IconButton>
        {showPicker && (
          <Box position="absolute" zIndex="2" ref={pickerRef}>
            <div className="color-picker-popover">
              <div className="color-picker-cover" onClick={handleClose} />
              <SketchPicker
                color={currentColor}
                onChangeComplete={handleColorChange}
                disableAlpha
                // Custom styles for the SketchPicker
                styles={{
                  default: {
                    picker: {
                      backgroundColor: "#fff", // Background color of the picker
                      border: "1px solid #227C9D", // Border color
                    },
                    saturation: {
                      boxShadow: "0 0 0 1px rgba(0,0,0,0.1)", // Shadow around the color area
                    },
                    hue: {
                      height: "8px", // Height of the hue slider
                      borderRadius: "4px", // Border radius of the hue slider
                      border: "1px solid #227C9D", // Border color of the hue slider
                    },
                    alpha: {
                      height: "8px", // Height of the alpha slider
                      borderRadius: "4px", // Border radius of the alpha slider
                      border: "1px solid #227C9D", // Border color of the alpha slider
                    },
                  },
                }}
              />
            </div>
          </Box>
        )}
      </Box>

      <Box
        // flex="0.6"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <h4>Hex Code: </h4>
      </Box>

      <Box
        flex="1"
        display="flex"
        alignItems="center"
        marginLeft={"10px"}
        marginRight={"10px"}
      >
        <TextField
          variant="outlined"
          size="small"
          value={currentColor}
          disabled
          InputProps={{
            style: {
              outline: "1px solid #227C9D",
              backgroundColor: "white",
              color:
                parseInt(currentColor?.replace("#", ""), 16) > 0xffffff / 2
                  ? "black"
                  : "white",
            },
          }}
        />
      </Box>
    </Box>
  );
};

export default ColorPickerWidget;
